/** 队服颜色选项（交互对齐 update-game.vue） */
export var JERSEY_COLOR_OPTIONS = [
  '#ffffff',
  '#2071B9',
  '#DF3A30',
  '#FFBC00',
  '#17AE5F',
  '#5F4284',
  '#EB6500',
  '#1F1F1F',
  '#F63C77',
  '#5ABDE1',
  '#DEF717'
]

var DETAIL_ROOT_KEYS = [
  'parentGame',
  'stageRule',
  'initialOrder',
  'rotationOrder',
  'waitingTeams',
  'currentChildGame',
  'childGames',
  'standing',
  'teamClothesColors',
  'teamJerseyColors'
]

export function normalizeClothesColor(color) {
  if (color === undefined || color === null) {
    return ''
  }
  var value = String(color).trim()
  if (!value) {
    return ''
  }
  if (value.charAt(0) !== '#' && /^[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/.test(value)) {
    return '#' + value
  }
  return value
}

/**
 * 接口可能返回 1-based 色板序号，或 hex 字符串
 */
export function resolveApiClothesColor(color) {
  if (color === undefined || color === null || color === '') {
    return ''
  }
  var raw = String(color).trim()
  if (!raw) {
    return ''
  }
  if (/^\d+$/.test(raw)) {
    var index = parseInt(raw, 10) - 1
    if (index >= 0 && index < JERSEY_COLOR_OPTIONS.length) {
      return JERSEY_COLOR_OPTIONS[index]
    }
  }
  return normalizeClothesColor(raw)
}

function parseJsonObject(value) {
  if (!value || typeof value !== 'string') {
    return null
  }
  try {
    var parsed = JSON.parse(value)
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch (e) {
    return null
  }
}

/**
 * teamClothesColors 可能是 map、数组或 JSON 字符串
 */
export function parseTeamClothesColorMap(source) {
  var map = {}
  if (!source) {
    return map
  }

  var data = source
  if (typeof source === 'string') {
    data = parseJsonObject(source)
    if (!data) {
      return map
    }
  }

  if (Array.isArray(data)) {
    data.forEach(function (item) {
      if (!item || typeof item !== 'object') {
        return
      }
      var id = item.teamId != null ? item.teamId : item.id
      var color = resolveApiClothesColor(
        item.clothesColor != null ? item.clothesColor : item.color
      )
      if (id != null && color) {
        map[String(id)] = color
      }
    })
    return map
  }

  if (typeof data === 'object') {
    Object.keys(data).forEach(function (key) {
      var color = resolveApiClothesColor(data[key])
      if (color) {
        map[String(key)] = color
      }
    })
  }

  return map
}

function mergeDetailField(detail, source, key) {
  if (!source || source[key] == null) {
    return
  }
  if (detail[key] == null) {
    detail[key] = source[key]
  }
}

function mergeDetailSources(detail, sources) {
  if (!detail) {
    return null
  }
  sources.forEach(function (source) {
    if (!source) {
      return
    }
    DETAIL_ROOT_KEYS.forEach(function (key) {
      mergeDetailField(detail, source, key)
    })
    if (source.parentGame && detail.parentGame) {
      mergeDetailField(detail, source.parentGame, 'initialOrder')
      mergeDetailField(detail, source.parentGame, 'rotationOrder')
      if (!detail.teamClothesColors && source.parentGame.teamClothesColors) {
        detail.teamClothesColors = source.parentGame.teamClothesColors
      }
      if (!detail.teamJerseyColors && source.parentGame.teamJerseyColors) {
        detail.teamJerseyColors = source.parentGame.teamJerseyColors
      }
    }
  })
  return detail
}

/**
 * AdminGet 响应 → 详情对象（合并 data 与顶层同名字段）
 */
export function pickWheelBattleApiDetail(res) {
  if (!res) {
    return null
  }

  var detail = null
  if (res.data && res.data.parentGame) {
    detail = Object.assign({}, res.data)
  } else if (res.parentGame) {
    detail = Object.assign({}, res)
  } else if (res.data && typeof res.data === 'object') {
    detail = Object.assign({}, res.data)
  }

  detail = mergeDetailSources(detail, [res, res.data])
  if (!detail || !detail.parentGame) {
    return null
  }
  return detail
}
